import { Component } from '@angular/core';

@Component({
  selector: 'app-nft-icon-default',
  templateUrl: './nft-icon-default.component.html',
  styleUrls: ['./nft-icon-default.component.scss']
})
export class NftIconDefaultComponent {

}
